import React from 'react';

const SlideFive = () => {
	return <div>SlideFive</div>;
};

export default SlideFive;
